import newForm from './newForm';
import {CustomSelect} from './newForm/select/custom-select';

const popupApplication = document.querySelector('.popup-application');

const openPopup = () => {
	document.querySelector('html').classList.add('is-lock-scroll');
	popupApplication.classList.add('is-open');
};

const closePopup = () => {
	document.querySelector('html').classList.remove('is-lock-scroll');
	popupApplication.classList.remove('is-open');
};

const getSelect = () => {
	const select = new CustomSelect();
	const getDataSelect = async (url) => {
		try {
			return await fetch(url);
		} catch (error) {
			select.init();

			return error;
		}
	};

	getDataSelect('https://kp-ecopremiya.9-lines.com/api/getNominations').then((response) => {
		if (response.ok) {
			return response.json();
		}
		select.init();
		throw new Error();
	}).then((responseJson) => {
		document.querySelector('.custom-select__list').querySelector('[data-select-value="selectinit"]').remove();
		responseJson.ITEMS.forEach((item) => {
			document.querySelector('.custom-select__list').insertAdjacentHTML('beforeend', `<li class="custom-select__item" data-select-value="${item.id}" aria-selected="false" role="option">${item.title}</li>`);
		});
		select.init();
	}).catch((error) => {
		console.log(error);
	});
};

const init = () => {
	if (!popupApplication) {
		return;
	}

	newForm.init();
	getSelect();

	document.querySelector('.js-popup-application').addEventListener('click', (e) => {
		e.preventDefault();
		openPopup();
	});

	popupApplication.querySelector('.js-popup-close').addEventListener('click', (e) => {
		e.preventDefault();
		closePopup();
	});
};

export default {
	init,
};
